<template>
    <van-popup
        v-if="customerApplyPopupShow"
        :value="customerApplyPopupShow"
        z-index="100"
        :close-on-click-overlay="false"
        :style="{ height: '100vh', width: '100vw', background: 'rgba(0,0,0,.3)' }"
        overlay-class="custom_popup"
        position="right"
    >
        <div class="public_container customer_apply_wrap" v-loading="loading">
            <div class="returnNavBar">
                <div class="returnNavBarLeft" @click="handleClickClose">
                    <van-icon name="arrow-left" />
                    <span class="normal_title">返回</span>
                </div>
            </div>
            <div class="mobile_container">
                <div class="operate_customer_list_box">
                    <div class="operate_customer_list_box_title">您确定要申领该客户吗？</div>
                    <ul class="operate_customer_list">
                        <li v-for="item in companyList" :key="item.id">
                            <p class="ellipsis">{{ item.name && item.name.value }}</p>
                        </li>
                    </ul>
                </div>
                <div class="operate_customer_list_box customer_apply_form">
                    <p class="customer_apply_form_title">审批流程</p>
                    <approveProcessSelect
                        ref="approveProcessSelectRef"
                        :approval_node_list="approval_node_list"
                    ></approveProcessSelect>
                </div>
            </div>
            <div class="add_footer_wrap">
                <van-button round block type="info" @click="handleClickConfirm">确定</van-button>
            </div>
        </div>
    </van-popup>
</template>
<script>
import { getApprovalNodes, CustomerClaim } from "@/api";
import approveProcessSelect from "@/components/mComponents/approveProcessSelect";
export default {
    name: "CustomerApply",
    components: { approveProcessSelect },
    props: {
        customerApplyPopupShow: {
            type: Boolean,
            default: false,
        },
        sea_id: "",
        companyList: {
            type: Array,
            default: []
        }
    },
    data() {
        return {
            loading: false,
            approval_node_list: [],
        };
    },
    created() {
        this.getgetApprovalNodesData();
    },
    methods: {
        handleClickClose() {
            this.$emit("update:customerApplyPopupShow", false)     
        },
        getgetApprovalNodesData() {
            getApprovalNodes({ approval_type: "customer_claim" }).then((res) => {
                if (res.code === 200) {
                    this.approval_node_list = res.data;
                    this.$refs.approveProcessSelectRef.set_approval_node_list(res.data);
                }
            });
        },
        handleClickConfirm() {
            if (this.$refs.approveProcessSelectRef.handleClickPublish() == false) {
                //审批节点校验没通过
                return false;
            }
            this.loading = true;
            const params = {
                seas_id: this.sea_id,
                customer_ids: this.companyList.map((item) => item.id),
                node_list: this.approval_node_list,
            };
            CustomerClaim(params)
                .then((res) => {
                    if (res.code === 200) {
                        this.$toast({
                            message: res.message,
                            type: "success",
                            duration: 1000,
                            onClose: () => {
                                this.$emit("update:customerApplyPopupShow", false)
                                this.$emit("applySuccess")
                            },
                        });
                    }
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
    }
};
</script>
<style lang="scss" scoped>
@import "@/styles/m_style/customers.scss";
.customer_apply_wrap {
    .mobile_container {
        padding: 10px 16px;
    }
    .customer_apply_form {
        padding: 10px;
        .customer_apply_form_title {
            position: relative;
            font-size: 14px;
            font-weight: 700;
            letter-spacing: 0px;
            line-height: 22px;
            color: rgba(51, 51, 51, 1);
            padding-left: 12px;
            margin-bottom: 15px;
            &::before {
                content: "";
                position: absolute;
                left: 0;
                top: 0;
                width: 4px;
                height: 22px;
                display: block;
                opacity: 1;
                border-radius: 10px;
                background: rgba(41, 144, 255, 1);
            }
        }
    }
}
</style>
